const schools = [
    {
        "title": "School of Management",
        "id": "school-of-management",
        "banner": "schoolofmanagement",
        "icon": "",
        "courses": [
            {
                "name": "doctor-of-philosophy-in-management",
                "title": "Doctor of Philosophy (Ph.D.) in Management",
                "school_name": "school-of-management",
                "department": "Management",
                "level": "Doctorate",
                "duration": "3 Years",
                "eligibility": "Post Graduation",
                "mode": "Semester",
                "banner_description": "<p>The Doctor of Philosophy (Ph.D.) in Management is a research-oriented program designed to prepare scholars for careers in academia, industry, and government.</p><p><br></p>"
            },
            {
                "name": "master-of-business-administration",
                "title": "Master Of Business Administration (Mba)",
                "school_name": "school-of-management",
                "department": "Management",
                "level": "Postgraduate",
                "duration": "2 Years (Full Time)",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>Pursuing an MBA course is an investment in your future. If you're interested in taking on a leadership role and earning opportunities to climb the corporate ladder, studying for your Master of Business Administration degree is a promising path.</p>"
            },
            {
                "name": "executive-master-of-business-administration",
                "title": "Executive Master of Business Administration (EMBA)",
                "school_name": "school-of-management",
                "department": "Management",
                "level": "Postgraduate",
                "duration": "18 Months",
                "eligibility": "Graduation or Equivalent (with 2 Years work experience)",
                "mode": "Semester",
                "banner_description": "<p>Executive Master of Business Administration is a full-time course designed so that individuals can understand their competencies to perform in an organization.<br></p>"
            },
            {
                "name": "bachelor-of-business-administration",
                "title": "Bachelor of Business Administration (BBA)",
                "school_name": "school-of-management",
                "department": "Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>A BBA course is a bachelor's degree programme pursued after the completion of high school. It is designed to equip students with essential business and management skills preparing them for successful careers in industry, trade & commerce. <br></p>"
            },
            {
                "name": "post-graduate-diploma-in-business-administration",
                "title": "Post Graduate Diploma in Business Administration (PGDBA)",
                "school_name": "school-of-management",
                "department": "Management",
                "level": "Post Graduate Diploma",
                "duration": "1 Year",
                "eligibility": "Graduation or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>A post graduate diploma in Business Administration will be of great help in polishing the knowledge and skills acquired during your Bachelors program.<br></p>"
            },
            {
                "name": "diploma-in-business-administration",
                "title": "Diploma in Business Administration (DBA)",
                "school_name": "school-of-management",
                "department": "Management",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>At ISBM University, students not just learn but gain experience that can help them for a lifetime. Our DBA (Diploma in Business Administration) offers an in depth training to function efficiently in an organization.<br></p>"
            },
            {
                "name": "post-graduate-diploma-in-business-management-pgdbm",
                "title": "Post Graduate Diploma In Business Management (PGDBM)",
                "school_name": "school-of-management",
                "department": "Management",
                "level": "Post Graduate Diploma",
                "duration": "2 Years",
                "eligibility": "Graduate or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The Post Graduate Diploma in Business Management (PGDBM) by ISBM University is a career-focused programme designed to develop managerial, analytical, and leadership capabilities required in today's dynamic business environment. The programme provides a comprehensive understanding of core business functions while helping students build strategic thinking, decision-making, and problem-solving skills.</p>"
            },
            {
                "name": "postgraduate-diploma-in-management-pgdm",
                "title": "Postgraduate Diploma In Management (PGDM)",
                "school_name": "school-of-management",
                "department": "Management",
                "level": "Post Graduate Diploma",
                "duration": "2 Years",
                "eligibility": "Graduation or equivalent",
                "mode": "Semester",
                "banner_description": "<p>The Post Graduate Diploma in Management (PGDM) by ISBM University is a professionally oriented postgraduation programme designed to develop future business leaders, managers, and entrepreneurs.The PGDM course is designed to offer strategic and business-focused insights to the aspiring leaders.</p>"
            }
        ]
    },
    {
        "title": "School of Science",
        "id": "school-of-science",
        "banner": "schoolofscience",
        "icon": "",
        "courses": [
            {
                "name": "doctor-of-philosophy-in-science",
                "title": "Doctor of Philosophy (Ph.D.) in Science",
                "school_name": "school-of-science",
                "department": "Science",
                "level": "Doctorate",
                "duration": "3 Years",
                "eligibility": "Post Graduation",
                "mode": "Semester",
                "banner_description": "<p>The Doctor of Philosophy (Ph.D.) at ISBM University's School of Science emphasizes innovative research work with the implementation of policies designed to improve the research infrastructure and new academic &amp; industry collaborations.<br></p>"
            },
            {
                "name": "master-of-science",
                "title": "Master Of Science (M.sc.)",
                "school_name": "school-of-science",
                "department": "Science",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation with Science (In related field of specialization)",
                "mode": "Semester",
                "banner_description": "<p>A Masters in Science degree is designed to help you demonstrate your proficiency is designed to enable you to project the prospect employers your level of expertise in a specific area of scientific study.</p>"
            },
            {
                "name": "msc-in-stem-cells-and-tissue-culture-engineering",
                "title": "M.Sc. in Stem Cells and Tissue Culture Engineering (M.Sc. SCTCE)",
                "school_name": "school-of-science",
                "department": "Science",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation with Science (In related field of specialization)",
                "mode": "Semester",
                "banner_description": "<p>The M.Sc. in Stem Cells and Tissue Culture Engineering (M.Sc. SCTCE) from ISBM University offers specialized knowledge in stem cells and tissue culture engineering, providing you with a deep understanding of the field. You will gain expertise in areas such as stem cell biology, tissue engineering principles, regenerative medicine, cell culture techniques, and bioengineering.<br></p>"
            },
            {
                "name": "msc-in-fire-and-safety",
                "title": "M.Sc. in Fire & Safety (M.Sc. F&S)",
                "school_name": "school-of-science",
                "department": "Science",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation with Science (In related field of specialization)",
                "mode": "Semester",
                "banner_description": "<p>The M.Sc. F&amp;S program provides students with in-depth knowledge and understanding of fire science, fire prevention, fire investigation, emergency planning, and other crucial aspects of fire and safety management. This specialized knowledge equips students with the skills and expertise necessary to handle various challenges in the field.<br></p>"
            },
            {
                "name": "msc-in-forensic-science-and-criminology",
                "title": "M.Sc. in Forensic Science & Criminology (M.Sc. FSC)",
                "school_name": "school-of-science",
                "department": "Science",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation with Science (In related field of specialization)",
                "mode": "Semester",
                "banner_description": "<p>With an M.Sc. in FSC, you can access a wide range of career opportunities in the field of forensic science and criminology. This degree can qualify you for positions in crime laboratories, law enforcement agencies, forensic consultancy firms, research organizations, and academic institutions.<br></p>"
            },
            {
                "name": "bachelor-of-science-honours",
                "title": "Bachelor of Science (Hons)",
                "school_name": "school-of-science",
                "department": "Science",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>B. Sc Hons deals with earning expertise through a deep-dive theoretical and practical understanding of one particular subject selected by the student.<br></p>"
            },
            {
                "name": "bachelor-of-science",
                "title": "Bachelor of Science (BSc)",
                "school_name": "school-of-science",
                "department": "Science",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent (with respective subjects)",
                "mode": "Semester",
                "banner_description": "<p>The BSc Course at ISBM University is designed to provide students with strong scientific knowledge & hands on training. The curriculum covers important BSc subjects with a focus on laboratory practicals, research exposure & learning across various scientific disciplines.<br></p>"
            },
            {
                "name": "bsc-in-forensic-science-and-criminology",
                "title": "B.Sc. in Forensic Science & Criminology (B.Sc. FSC)",
                "school_name": "school-of-science",
                "department": "Science",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent (with respective subjects)",
                "mode": "Semester",
                "banner_description": "<p>Forensic science and criminology are dynamic and rapidly evolving fields with a growing demand for qualified professionals. By obtaining a B.Sc. FSC degree, you enhance your employability and open doors to a wide range of career opportunities.<br></p>"
            },
            {
                "name": "bsc-in-fire-and-safety",
                "title": "B.Sc. in Fire & Safety",
                "school_name": "school-of-science",
                "department": "Science",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent (with respective subjects)",
                "mode": "Semester",
                "banner_description": "<p>A B.Sc. in Fire &amp; Safety equips students with a comprehensive understanding of fire dynamics, fire prevention techniques, fire protection systems, and emergency response protocols. This knowledge is crucial for professionals working in fire departments, industrial safety, construction, or any field where fire hazards exist.<br></p>"
            },
            {
                "name": "post-graduate-diploma-in-science",
                "title": "Post Graduate Diploma in Science (PGDSC)",
                "school_name": "school-of-science",
                "department": "Science",
                "level": "Post Graduate Diploma",
                "duration": "1 Year",
                "eligibility": "Graduation with Science (In related field of specialization)",
                "mode": "Annual",
                "banner_description": "<p>Advance your scientific career with a Post Graduate Diploma in Science (PGDSC) and gain practical knowledge and skills to excel in your field.<br></p>"
            },
            {
                "name": "diploma-in-nutrition",
                "title": "Diploma in Nutrition (DIN)",
                "school_name": "school-of-science",
                "department": "Science",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>ISBM University is committed to building a strong and sustainable Indian health and sport industry workforce. Successful graduates from this diploma program are well-placed to progress to become qualified as a dietitian.<br></p>"
            },
            {
                "name": "diploma-in-science",
                "title": "Diploma in Science",
                "school_name": "school-of-science",
                "department": "Science",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>The curriculum of a Diploma in Science program is designed to provide students with the necessary skills and knowledge to pursue careers in various fields, such as research and development, quality control, scientific writing, teaching, and more.<br></p>"
            },
            {
                "name": "diploma-in-forensic-science-and-criminology",
                "title": "Diploma in Forensic Science & Criminology",
                "school_name": "school-of-science",
                "department": "Science",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 in Science Stream",
                "mode": "Semester",
                "banner_description": "<p>The field of forensic science and criminology offers diverse career opportunities. With a diploma from ISBM University, you can pursue a career as a forensic scientist, crime scene investigator, forensic analyst, criminal profiler, or work in law enforcement agencies, government forensic laboratories, private forensic organizations, or research institutions.<br></p>"
            }
        ]
    },
    {
        "title": "School of Commerce",
        "id": "school-of-commerce",
        "banner": "schoolofcommerce",
        "icon": "",
        "courses": [
            {
                "name": "doctor-of-philosophy-in-commerce",
                "title": "Doctor of Philosophy (Ph.D.) in Commerce",
                "school_name": "school-of-commerce",
                "department": "Commerce",
                "level": "Doctorate",
                "duration": "3 Years",
                "eligibility": "Post Graduation",
                "mode": "Semester",
                "banner_description": "<p>A Ph.D. in Commerce is a highly-specialized degree, which helps individuals in a wide variety of fields. The degree is designed to increase the professionally of individuals in the field of commerce and business. This doctoral degree allows candidates to gain in-depth knowledge in the fields of finance and accounting.<br></p>"
            },
            {
                "name": "master-of-commerce",
                "title": "Master of Commerce (M.Com)",
                "school_name": "school-of-commerce",
                "department": "Commerce",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The M.Com courses are in high demand due to the financial benefits it provides to the candidates. The M.Com courses are available in different modes and the large amount of specialization allows the candidates to carve a niche among the different industries.<br></p>"
            },
            {
                "name": "bcom-in-computer-application",
                "title": "B.Com in Computer Application",
                "school_name": "school-of-commerce",
                "department": "Commerce",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>B.Com (Bachelor of Commerce) in Computer Application from ISBM University can be a valuable degree for individuals interested in pursuing a career that combines commerce and computer applications.<br></p>"
            },
            {
                "name": "bachelor-of-commerce-honours",
                "title": "Bachelor of Commerce (Hons)",
                "school_name": "school-of-commerce",
                "department": "Commerce",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>A Bachelor of Commerce (Hons) degree is highly regarded by employers, as it demonstrates a strong academic foundation in business and related disciplines.<br></p>"
            },
            {
                "name": "bachelor-of-commerce",
                "title": "Bachelor Of Commerce (B.com)",
                "school_name": "school-of-commerce",
                "department": "Commerce",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p dir=\"ltr\">Bachelor of Commerce program provides a fundamental education in the field of commerce. Through its career-focused curriculum, a Bachelor of Commerce degree prepares efficient professionals ready to join the workforce across industries and organizations.</p>\r\n<p>&nbsp;</p>"
            },
            {
                "name": "post-graduate-diploma-in-commerce",
                "title": "Post Graduate Diploma in Commerce (PGDCOM)",
                "school_name": "school-of-commerce",
                "department": "Commerce",
                "level": "Post Graduate Diploma",
                "duration": "1 Year",
                "eligibility": "Graduation or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>PGDCOM is a postgraduate diploma program that focuses on advanced concepts in commerce, accounting, finance, and management. It equips students with the knowledge and skills needed for a successful career in the business world.<br></p>"
            },
            {
                "name": "diploma-in-commerce",
                "title": "Diploma in Commerce",
                "school_name": "school-of-commerce",
                "department": "Commerce",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>A Diploma in Commerce equips students with practical knowledge of accounting, economics, and business management. Graduates of this program are well-prepared to pursue a variety of careers in the world of business and finance.<br></p>"
            }
        ]
    },
    {
        "title": "School of Arts and Humanities",
        "id": "school-of-arts-and-humanities",
        "banner": "schoolofarts",
        "icon": "",
        "courses": [
            {
                "name": "doctor-of-philosophy-in-arts-and-humanities",
                "title": "Doctor of Philosophy (Ph.D.) in Arts and Humanities",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Doctorate",
                "duration": "3 Years",
                "eligibility": "Post Graduation",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "master-of-arts",
                "title": "Master of Arts (M.A)",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent (with 2 Years work experience)",
                "mode": "Semester",
                "banner_description": "<p>Taking a Master of Arts degree can offer a number of diverse benefits ranging from enhanced career prospects to improved problem-solving and decision-making skills.</p>"
            },
            {
                "name": "master-of-social-work",
                "title": "Master of Social Work (MSW)",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>MSW programs may also require students to complete a supervised field placement in a social work setting, which provides hands-on experience working with individuals, families, and communities.</p>"
            },
            {
                "name": "bachelor-of-arts-honours",
                "title": "Bachelor of Arts (Hons)",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The Bachelor of Arts (Degree with honours) is a specialized year of study for students who have achieved academic excellence in their undergraduate degree. An honours year enables you to extend your knowledge of your area of specialization.</p>"
            },
            {
                "name": "bachelor-of-arts",
                "title": "Bachelor Of Arts (B.a)",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>Bachelor of Arts Degree or BA program is an Undergraduate Academic Degree awarded for a course or program usually in a branch of the Liberal Arts,the Sciences, or both. The Bachelor of Arts degree is one of the oldest and best-known degrees in the world.</p>"
            },
            {
                "name": "bachelor-of-social-work",
                "title": "Bachelor of Social Work (BSW)",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The Bachelor of Social Work program will enable students to acquire social morals, principles and values essential to become praiseworthy social workers.</p>"
            },
            {
                "name": "post-graduate-diploma-in-rural-development",
                "title": "Post Graduate Diploma in Rural Development",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Post Graduate Diploma",
                "duration": "1 Year",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>A Post Graduate Diploma in Rural Development is a specialized program designed to equip individuals with the knowledge and skills required to effectively address the development needs of rural areas. The program covers various aspects of rural development such as agriculture, natural resource management, rural infrastructure, social and economic development, and community empowerment.</p>"
            },
            {
                "name": "masters-of-arts-in-english",
                "title": "Masters of Arts in English",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "master-of-arts-in-hindi",
                "title": "Master of Arts in Hindi",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "master-of-arts-in-chhattisgarhi",
                "title": "Master of Arts in Chhattisgarhi",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": "<p><br></p>"
            },
            {
                "name": "master-of-arts-in-philosophy",
                "title": "Master of Arts in Philosophy",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "master-of-arts-in-history-and-archaeology",
                "title": "Master of Arts in History and Archaeology",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "master-of-arts-in-politic-science",
                "title": "Master of Arts in Politic Science",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "master-of-arts-in-public-administration",
                "title": "Master of Arts in Public Administration",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "master-of-arts-in-economics",
                "title": "Master of Arts in Economics",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "master-of-arts-in-education",
                "title": "Master of Arts in Education",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "master-of-arts-in-sociology",
                "title": "Master of Arts in Sociology",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "master-of-arts-in-geography",
                "title": "Master of Arts in Geography",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "master-of-arts-in-psycology",
                "title": "Master of Arts in Psycology",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "master-of-arts-in-sanskrit",
                "title": "Master of Arts in Sanskrit",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "master-of-arts-in-disaster-management",
                "title": "Master of Arts in Disaster Management",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "master-of-arts-in-public-health",
                "title": "Master of Arts in Public Health",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "ba-honours-disaster-management",
                "title": "Ba (Honours) Disaster Management",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Undergraduate",
                "duration": "4 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p dir=\"ltr\">BA (Honours) Disaster Management is an interdisciplinary undergraduate programme with an emphasis on the phases of the disaster cycle: mitigation, preparedness, response and recovery. This degree programme by ISBM University in Chhattisgarh, trains students to cope with natural and man-made disasters through the study of risk assessment, humanitarian relief and emergency logistics.</p>\n<p>&nbsp;</p>"
            },
            {
                "name": "ma-disaster-management",
                "title": "Ma Disaster Management",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": "<p dir=\"ltr\">MA in Disaster Management is a 2-year postgraduate degree program that emphasizes the complex relationship between social and environmental issues through the development of geospatial technology with a view to developing community resilience. This degree programme by ISBM University in Chhattisgarh &ndash; Raipur and Gariyaband, equips graduates for careers in emergency management, climate adaptation, and humanitarian aid.</p>"
            },
            {
                "name": "ma-physical-education-sports",
                "title": "Ma (Physical Education & Sports)",
                "school_name": "school-of-arts-and-humanities",
                "department": "Arts and Humanities",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The MA in Physical Education and Sports at ISBM University, is a 2-year postgraduate program designed to build advanced expertise in sports science, physical fitness, and pedagogy. It opens up career paths like physical education teaching, sports coaching, and sports administration.</p>"
            }
        ]
    },
    {
        "title": "School of Engineering and Technology",
        "id": "school-of-engineering-and-technology",
        "banner": "schoolofeng",
        "icon": "",
        "courses": [
            {
                "name": "doctor-of-philosophy-in-engineering-and-technology",
                "title": "Doctor of Philosophy (Ph.D.) in Engineering and Technology",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Doctorate",
                "duration": "3 Years",
                "eligibility": "Post Graduation",
                "mode": "Semester",
                "banner_description": "<p>A Doctor of Philosophy (Ph.D.) in Engineering and Technology is an advanced academic degree that prepares students to become experts in a specific field of engineering or technology. The program typically requires students to conduct original research in their area of specialization, leading to the development of new theories, designs, and applications.</p>"
            },
            {
                "name": "master-of-technology",
                "title": "Master of Technology (M.Tech)",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": "<p>M. Tech is designed to produce Research Engineers who can get the position of Technologist in the industries and research institutes.</p>"
            },
            {
                "name": "bachelor-of-technology",
                "title": "Bachelor of Technology (B.Tech)",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Undergraduate",
                "duration": "4 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>Bachelor of Technology (B. Tech) is a professional undergraduate engineering degree program awarded to candidates after they complete four years of study in the field.</p>"
            },
            {
                "name": "bachelor-of-technology-lateral",
                "title": "Bachelor of Technology (B.Tech) (Lateral Entry)",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "Diploma in Engineering (3 Years) (in respective specialization from recognized institute)",
                "mode": "Semester",
                "banner_description": "<p>Bachelor of Technology (B.Tech) (Lateral Entry) is an undergraduate degree program designed for diploma holders or students who have completed a 3-year diploma program in engineering or technology. The program offers an opportunity to complete the B.Tech degree in a shorter duration of 3 years instead of the regular 4 years.</p>"
            },
            {
                "name": "diploma-in-engineering",
                "title": "Diploma in Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Diploma",
                "duration": "3 Years",
                "eligibility": "10th or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The Diploma in Engineering is a program focused on practical and skills-oriented training. It aims to provide students with industry or job related engineering knowledge, scientific skills, computing and analysis, mathematical techniques, a sound knowledge of English to communicate in the field and ability to apply problem-solving techniques.</p>"
            },
            {
                "name": "diploma-in-engineering-lateral",
                "title": "Diploma in Engineering (Lateral Entry)",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Diploma",
                "duration": "2 Years",
                "eligibility": "10+2 PCM/ITI (2 Years) (2 years Vocational Course in Relevant Trade/3 year Apprenticeship)",
                "mode": "Semester",
                "banner_description": "<p>A Diploma in Engineering (DE) (Lateral Entry) program is designed for students who have completed a technical diploma or vocational training in a related field and wish to further their education and career prospects in engineering.</p>"
            },
            {
                "name": "mtech-in-computer-science",
                "title": "M.tech In Computer Science",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": "<p>The MTech in Computer Science is a 2-year postgraduate program designed to provide advanced knowledge in computing technologies, software systems, artificial intelligence, data science, cybersecurity, and emerging digital innovations. The program prepares graduates to solve complex technological challenges and pursue leadership roles in the rapidly evolving IT industry.</p>"
            },
            {
                "name": "mtech-in-civil-engineering",
                "title": "M.Tech in Civil Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "mtech-in-mechanical-engineering",
                "title": "M.Tech in Mechanical Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "mtech-in-mining-engineering",
                "title": "M.Tech in Mining Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "mtech-in-electronics-engineering",
                "title": "M.Tech in Electronics Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "mtech-in-e-security",
                "title": "M.Tech in E Security",
                "school_name": "school-of-engineering-and-technology",
                "department": "Science",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "mtech-in-computer-technology",
                "title": "M.Tech in Computer Technology",
                "school_name": "school-of-engineering-and-technology",
                "department": "Science",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "mtech-in-software-engineering",
                "title": "M.Tech in Software Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Science",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "mtech-in-structural",
                "title": "M.Tech in Structural",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "mtech-in-construction-technology-and-management",
                "title": "M.Tech in Construction Technology & Management",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "mtech-in-geo-technical-engineering",
                "title": "M.Tech in Geo Technical Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "mtech-in-highway-engineering",
                "title": "M.Tech in Highway Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "mtech-in-production",
                "title": "M.Tech in Production",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "mtech-in-energy-management",
                "title": "M.Tech in Energy Management",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "mtech-in-thermal",
                "title": "M.Tech in Thermal",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "mtech-in-safety",
                "title": "M.Tech in Safety",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B. Tech (in respective specialization)",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "btech-in-civil-engineering",
                "title": "B.Tech in Civil Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Undergraduate",
                "duration": "4 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "btech-in-mechanical-engineering",
                "title": "B.Tech in Mechanical Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Undergraduate",
                "duration": "4 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "btech-in-electronics-and-electrical-engineering",
                "title": "B.Tech in Electrical & Electronics Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Undergraduate",
                "duration": "4 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "btech-in-computer-science",
                "title": "B.Tech in Computer Science",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Undergraduate",
                "duration": "4 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "btech-in-mining-engineering",
                "title": "B.Tech in Mining Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Undergraduate",
                "duration": "4 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "btech-in-information-technology",
                "title": "B.Tech in Information Technology",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Undergraduate",
                "duration": "4 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "btech-in-chemical-engineering",
                "title": "B.Tech in Chemical Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Undergraduate",
                "duration": "4 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "diploma-in-civil-engineering",
                "title": "Diploma in Civil Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Diploma",
                "duration": "3 Years",
                "eligibility": "10th or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "diploma-in-mechanical-engineering",
                "title": "Diploma in Mechanical Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Diploma",
                "duration": "3 Years",
                "eligibility": "10th or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "diploma-in-electronics-and-electrical-engineering",
                "title": "Diploma in Electrical & Electronics Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Diploma",
                "duration": "3 Years",
                "eligibility": "10th or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "diploma-in-computer-science",
                "title": "Diploma in Computer Science",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Diploma",
                "duration": "3 Years",
                "eligibility": "10th or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "diploma-in-mining-engineering",
                "title": "Diploma in Mining Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Diploma",
                "duration": "3 Years",
                "eligibility": "10th or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "diploma-in-chemical-engineering",
                "title": "Diploma in Chemical Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Diploma",
                "duration": "3 Years",
                "eligibility": "10th or Equivalent",
                "mode": "Semester",
                "banner_description": ""
            },
            {
                "name": "bachelor-of-technology-btech-in-artificial-intelligence-machine-learning",
                "title": "Bachelor Of Technology (B.tech) In Artificial Intelligence & Machine Learning",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Undergraduate",
                "duration": "4 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p dir=\"ltr\">A future-focused engineering program that equips students with the skills to design intelligent systems, analyze data, and develop machine learning solutions for real-world applications across industries.</p>"
            },
            {
                "name": "bachelor-of-technology-btech-in-cyber-security-blockchain",
                "title": "Bachelor Of Technology (B.tech) In Cyber Security & Blockchain",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Undergraduate",
                "duration": "4 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p dir=\"ltr\">A technology-driven engineering program focused on digital security, blockchain systems, and secure computing practices, preparing students to protect information assets and develop trusted digital infrastructures.</p>"
            },
            {
                "name": "bachelor-of-technology-btech-in-data-science-data-engineering",
                "title": "Bachelor Of Technology (B.tech) In Data Science & Data Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Undergraduate",
                "duration": "4 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p dir=\"ltr\">A future-oriented engineering program designed to equip students with the skills to collect, manage, analyze, and transform data into actionable insights while building scalable data systems for modern organizations.</p>"
            },
            {
                "name": "bachelor-of-technology-btech-in-ai-data-analytics",
                "title": "Bachelor Of Technology (B.tech) In Ai & Data Analytics",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Undergraduate",
                "duration": "4 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p dir=\"ltr\">A cutting-edge engineering program designed to prepare students for the future of intelligent technologies by combining Artificial Intelligence, data analytics, and decision-driven business intelligence.</p>"
            },
            {
                "name": "master-of-technology-mtech-in-artificial-intelligence-machine-learning",
                "title": "Master Of Technology (M.tech) In Artificial Intelligence & Machine Learning",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B.Tech / B.E. or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>An advanced postgraduate engineering program designed to develop expertise in Artificial Intelligence, Machine Learning, and intelligent systems while preparing professionals for leadership roles in emerging technology domains.</p>"
            },
            {
                "name": "master-of-technology-mtech-in-cyber-security-blockchain",
                "title": "Master Of Technology (M.tech) In Cyber Security & Blockchain",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B.Tech / B.E. or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>An advanced postgraduate engineering program focused on digital security, blockchain innovation, and secure technology systems, preparing professionals to address modern cybersecurity challenges and decentralized digital transformation.</p>"
            },
            {
                "name": "master-of-technology-mtech-in-data-science-data-engineering",
                "title": "Master Of Technology (M.tech) In Data Science & Data Engineering",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B.Tech / B.E. or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>An advanced postgraduate engineering program designed to build expertise in large-scale data systems, advanced analytics, and data-driven technologies that support intelligent decision-making across industries.</p>"
            },
            {
                "name": "master-of-technology-mtech-in-artificial-intelligence-data-analytics",
                "title": "Master Of Technology (M.tech) In Artificial Intelligence & Data Analytics",
                "school_name": "school-of-engineering-and-technology",
                "department": "Engineering",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B.Tech / B.E. or Equivalent",
                "mode": "Semester",
                "banner_description": "<p dir=\"ltr\">An advanced postgraduate engineering program designed to build expertise in artificial intelligence, data analytics, and intelligent decision systems for solving complex real-world problems across industries.</p>"
            }
        ]
    },
    {
        "title": "School of Information and Technology",
        "id": "school-of-information-and-technology",
        "banner": "schoolofit",
        "icon": "",
        "courses": [
            {
                "name": "doctor-of-philosophy-in-information-technology",
                "title": "Doctor of Philosophy (Ph.D.) in Information Technology",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Doctorate",
                "duration": "3 Years",
                "eligibility": "Post Graduation",
                "mode": "Semester",
                "banner_description": "<p>Ph.D. IT is one of the highest degrees offered and any candidate who has completed post- graduation or Master of the respective field. This degree is specialized for candidates looking forward to launching an extensively active career in the field of information technology.</p>"
            },
            {
                "name": "msc-in-information-technology",
                "title": "M.sc. In Information Technology (M.sc It)",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation in relavent field",
                "mode": "Semester",
                "banner_description": "<p>By pursuing a Master of Information Technology degree students deepen their understanding about the current trends in the Information Technology arena. The Masters Degree in IT is designed for advanced learning in functioning and structure of emerging technologies.</p>"
            },
            {
                "name": "msc-in-computer-science",
                "title": "M.Sc. in Computer Science (M.Sc. CS)",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation in relavent field",
                "mode": "Semester",
                "banner_description": "<p>The M.Sc. Computer Science course is designed to equip the knowledge and skills to develop innovative solutions which the modern computing industry requires.</p>"
            },
            {
                "name": "master-of-computer-applications",
                "title": "Master of Computer Applications (MCA)",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation in relavent field",
                "mode": "Semester",
                "banner_description": "<p>Master of Computer Applications (MCA) is a postgraduate program that focuses on providing students with advanced knowledge and skills in the field of computer science and applications.</p>"
            },
            {
                "name": "msc-in-data-science",
                "title": "M.Sc. in Data Science",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation in relavent field",
                "mode": "Semester",
                "banner_description": "<p>A M.Sc. in Data Science program prepares students with the technical and analytical skills required to work with big data. This program typically focuses on teaching students how to collect, analyze, and interpret data using statistical methods and programming languages such as Python and R.</p>"
            },
            {
                "name": "bsc-in-information-technology",
                "title": "B.Sc. (Hons) in Information Technology",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 in Science Stream (with respective subjects)",
                "mode": "Semester",
                "banner_description": "<p>The B.Sc. (Hons) in Information Technology is an undergraduate degree program that provides students with a comprehensive understanding of various aspects of information technology. The program covers topics such as computer programming, web development, database management, networking, cybersecurity, and project management.</p>"
            },
            {
                "name": "bsc-in-computer-science",
                "title": "B.Sc. (Hons) in Computer Science",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 in Science Stream (with respective subjects)",
                "mode": "Semester",
                "banner_description": "<p>B.Sc. (Hons) in Computer Science is an undergraduate course that includes all the aspects of computer science and related subjects that are necessary to make a career in the software industry.</p>"
            },
            {
                "name": "bachelor-of-computer-applications",
                "title": "Bachelor Of Computer Applications (Bca)",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>A BCA program is an undergraduate degree pathway by ISBM University &nbsp;that offers students a comprehensive education in computer science and its practical applications. The BCA course covers a broad range of subjects, including programming languages, algorithms, database management, computer networks, web development, and software engineering.</p>"
            },
            {
                "name": "bsc-in-data-science",
                "title": "B.Sc. in Data Science",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 in Science Stream (with respective subjects)",
                "mode": "Semester",
                "banner_description": "<p>A B.Sc. in Data Science is a multidisciplinary undergraduate degree program that combines computer science, statistics, and domain-specific knowledge to extract insights from large and complex datasets. Students learn to design, implement and evaluate data-driven solutions to real-world problems using advanced data analysis and visualization techniques.</p>"
            },
            {
                "name": "post-graduate-diploma-in-computer-application",
                "title": "Post Graduate Diploma in Computer Application (PGDCA)",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Post Graduate Diploma",
                "duration": "1 Year",
                "eligibility": "Graduation or Equivalent (Pass with Maths as core subject)",
                "mode": "Annual",
                "banner_description": "<p>Post Graduate Diploma in Computer Application (PGDCA) is a one-year postgraduate diploma program that provides students with an in-depth understanding of computer applications and programming languages. The course aims to develop analytical and technical skills that are essential for the development of software applications.</p>"
            },
            {
                "name": "post-graduate-diploma-in-data-science",
                "title": "Post Graduate Diploma in Data Science",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Post Graduate Diploma",
                "duration": "1 Year",
                "eligibility": "Graduation or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>A Post Graduate Diploma in Data Science is a specialized program that focuses on the use of statistical and computational methods to extract insights and knowledge from data. This program equips students with the technical skills required to collect, store, process, analyze, and visualize data from various sources.</p>"
            },
            {
                "name": "post-graduate-diploma-in-ai-and-ml",
                "title": "Post Graduate Diploma in AI & ML",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Post Graduate Diploma",
                "duration": "1 Year",
                "eligibility": "Graduation or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>A Post Graduate Diploma in AI &amp; ML is a program that provides students with advanced skills and knowledge in the field of AI and ML. The program covers topics such as data analysis, machine learning algorithms, neural networks, deep learning, and natural language processing.</p>"
            },
            {
                "name": "diploma-in-computer-application",
                "title": "Diploma in Computer Application (DCA)",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>Diploma in Computer Applications (DCA) is a one-year diploma course that focuses on imparting basic computer skills to students. The course covers topics such as computer fundamentals, operating systems, programming languages, database management, and internet technologies.</p>"
            },
            {
                "name": "diploma-in-ai-and-ml",
                "title": "Diploma in AI & ML",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>A Diploma in AI &amp; ML is a specialized program that provides students with a comprehensive understanding of the principles, techniques, and applications of artificial intelligence and machine learning.</p>"
            },
            {
                "name": "advance-diploma-in-computer-applications-adca",
                "title": "Advance Diploma In Computer Applications (ADCA)",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The Advanced Diploma in Computer Applications (ADCA) by ISBM University is a career-oriented diploma programme designed to provide comprehensive knowledge of computer applications, software systems, and information technology. Designed for students and professionals seeking to strengthen their IT capabilities, the programme prepares graduates for a wide range of roles in computer operations, technical support, data management, software applications, and administrative technology functions.</p>"
            },
            {
                "name": "bachelor-of-science-bsc-in-devops-full-stack-development",
                "title": "Bachelor Of Science (B.sc) In Devops & Full Stack Development",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>A practical undergraduate program designed to build end-to-end software development skills along with modern DevOps practices for building, deploying, and managing scalable applications.</p>"
            },
            {
                "name": "bachelor-of-science-bsc-in-internet-of-things-iot",
                "title": "Bachelor Of Science (B.sc) In Internet Of Things (Iot)",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p dir=\"ltr\">A future-focused undergraduate program designed to develop skills in connected devices, smart systems, and embedded technologies that power modern automation and digital ecosystems.</p>"
            },
            {
                "name": "bachelor-of-science-bsc-in-cloud-computing",
                "title": "Bachelor Of Science (B.sc) In Cloud Computing",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p dir=\"ltr\">A modern undergraduate program designed to build strong foundational skills in cloud technologies, distributed systems, and scalable computing solutions used in today&rsquo;s digital infrastructure.</p>"
            },
            {
                "name": "bachelor-of-science-bsc-in-full-stack-development",
                "title": "Bachelor Of Science (B.sc) In Full Stack Development",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p dir=\"ltr\">A practical undergraduate program designed to build end-to-end software development skills, covering both front-end and back-end technologies used in modern web and application development.</p>"
            },
            {
                "name": "bachelor-of-science-bsc-in-computer-science-business-intelligence",
                "title": "Bachelor Of Science (B.sc) In Computer Science & Business Intelligence",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>A multidisciplinary undergraduate program designed to build strong foundations in computing, data systems, and business intelligence for data-driven decision-making in modern organizations.</p>"
            },
            {
                "name": "bachelor-of-science-bsc-in-artificial-intelligence-machine-learning",
                "title": "Bachelor Of Science (B.sc) In Artificial Intelligence & Machine Learning",
                "school_name": "school-of-information-and-technology",
                "department": "IT",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>A foundational undergraduate program designed to introduce students to intelligent systems, data-driven technologies, and core principles of Artificial Intelligence and Machine Learning for modern computing applications.</p>"
            }
        ]
    },
    {
        "title": "School of Design",
        "id": "school-of-design",
        "banner": "schoolofdesign",
        "icon": "",
        "courses": [
            {
                "name": "bsc-in-fashion-designing",
                "title": "B.Sc. (Hons) in Fashion Designing",
                "school_name": "school-of-design",
                "department": "Design",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>B.Sc. (Hons) in Fashion Design is the study of creating designs that involve the conversion of artistic talent and creativity into creating saleable products like clothing, textiles, jewelry, footwear, and other accessories.</p>"
            },
            {
                "name": "bsc-in-interior-design",
                "title": "B.Sc. (Hons) in Interior Design",
                "school_name": "school-of-design",
                "department": "Design",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>B.Sc. (Hons) in Interior Design is an undergraduate program that focuses on the design and management of interior spaces. Graduates of a B.Sc. (Hons) in Interior Design program can pursue careers in a variety of industries, including architecture and design firms, real estate development companies, hospitality and tourism, and retail design.</p>"
            },
            {
                "name": "diploma-in-fashion-designing",
                "title": "Diploma in Fashion Designing (DFD)",
                "school_name": "school-of-design",
                "department": "Design",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>A Diploma in Fashion Designing (DFD) is a program designed to provide students with the skills and knowledge needed to pursue a career in the fashion industry. The program focuses on various aspects of fashion design, including pattern making, garment construction, textiles, fashion illustration, and merchandising.</p>"
            },
            {
                "name": "diploma-in-interior-design",
                "title": "Diploma in Interior Design (DID)",
                "school_name": "school-of-design",
                "department": "Design",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>A Diploma in Interior Design (DID) is a professional qualification that prepares students to work in the field of interior design. The program covers various aspects of interior design, including space planning, color theory, furniture design, lighting, materials, and construction.</p>"
            },
            {
                "name": "diploma-in-product-design",
                "title": "Diploma in Product Design",
                "school_name": "school-of-design",
                "department": "Design",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>A diploma in product design is a program that focuses on teaching students the skills and knowledge needed to create and design various products, from concept to production. This program typically combines theoretical and practical coursework, with an emphasis on hands-on experience and collaboration with other students.</p>"
            },
            {
                "name": "diploma-in-jewellery-design",
                "title": "Diploma in Jewellery Design",
                "school_name": "school-of-design",
                "department": "Design",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>A Diploma in Jewellery Design is a course of study that focuses on the creation, design, and production of jewelry. It is a program that aims to provide students with the knowledge and skills needed to develop their creativity and create unique, marketable jewelry designs.</p>"
            },
            {
                "name": "certificate-in-fashion-designing",
                "title": "Certificate in Fashion Designing (CFD)",
                "school_name": "school-of-design",
                "department": "Design",
                "level": "Certificate",
                "duration": "6 Months",
                "eligibility": "10th or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>Certificate in Fashion Designing will act as a stepping stone for students in order to pursue their higher studies in Fashion Designing.</p>"
            },
            {
                "name": "certificate-in-interior-design",
                "title": "Certificate in Interior Design (CID)",
                "school_name": "school-of-design",
                "department": "Design",
                "level": "Certificate",
                "duration": "6 Months",
                "eligibility": "10th or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The Certificate in Interior Design (CID) is a program that provides individuals with the skills and knowledge necessary to pursue a career in interior design. The program covers the fundamental principles of design, including color theory, space planning, lighting, and materials selection.</p>"
            },
            {
                "name": "msc-in-interior-design",
                "title": "Msc In Interior Design",
                "school_name": "school-of-design",
                "department": "Design",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduate or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>MSc in Interior Design is a postgraduate pathway that advances your knowledge on the design and management of interior spaces. Graduates of MSc in Interior Design from ISBM University, Chhattisgarh &ndash; Raipur and Gariyaband can pursue careers in a variety of industries, including architecture and design firms, real estate development companies, hospitality and tourism, and retail design.</p>"
            },
            {
                "name": "msc-in-fashion-design",
                "title": "Msc In Fashion Design",
                "school_name": "school-of-design",
                "department": "Design",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduate or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>MSc in Fashion Design at ISBM University, Chhattisgarh, is an advanced, career-oriented study of creating designs that involve the conversion of artistic talent and creativity into creating saleable products like clothing, textiles, jewelry, footwear, and other accessories.</p>"
            }
        ]
    },
    {
        "title": "School of Pharmacy",
        "id": "school-of-pharmacy",
        "banner": "schoolofpharmacy",
        "icon": "",
        "courses": [
            {
                "name": "doctor-of-philosophy-in-pharmacy",
                "title": "Doctor of Philosophy (Ph.D.) in Pharmacy",
                "school_name": "school-of-pharmacy",
                "department": "Pharmacy",
                "level": "Doctorate",
                "duration": "3 Years",
                "eligibility": "Post Graduation",
                "mode": "Semester",
                "banner_description": "<p>A Ph.D. in Pharmacy program typically involves advanced coursework in pharmaceutical sciences, pharmacology, pharmacokinetics, pharmacodynamics, and other related disciplines.</p>"
            },
            {
                "name": "master-of-pharmacy",
                "title": "Master of Pharmacy (M Pharma)",
                "school_name": "school-of-pharmacy",
                "department": "Pharmacy",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "B-Pharma (with minimum 50% Marks)",
                "mode": "Semester",
                "banner_description": "<p>The Master of Pharmacy is a postgraduate degree program for advanced students who seek to expand their knowledge and command of pharmacy to go on to more demanding positions in the areas of community pharmacy, clinical pharmacy, veterinary pharmacy, military pharmacy or specialty pharmacy, as well as pharmacy informatics.</p>"
            },
            {
                "name": "bachelor-of-pharmacy",
                "title": "Bachelor of Pharmacy (B Pharma)",
                "school_name": "school-of-pharmacy",
                "department": "Pharmacy",
                "level": "Undergraduate",
                "duration": "4 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>If you are inclined towards studying Pharmaceutical Science rather than opting for the rigorous study of medicine and surgery, then B Pharmacy is a good choice for you.</p>"
            },
            {
                "name": "diploma-in-pharmacy",
                "title": "Diploma in Pharmacy (D Pharma)",
                "school_name": "school-of-pharmacy",
                "department": "Pharmacy",
                "level": "Diploma",
                "duration": "2 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>Diploma in Pharmacy (D-Pharma) is a two-year academic program that provides students with the knowledge and skills required to become a pharmacist. This course covers a wide range of topics such as the formulation, preparation, testing, dispensing, and storage of drugs.</p>"
            }
        ]
    },
    {
        "title": "School of Life Science",
        "id": "school-of-life-science",
        "banner": "schooloflifesci",
        "icon": "",
        "courses": [
            {
                "name": "doctor-of-philosophy-in-life-science",
                "title": "Doctor of Philosophy (Ph.D.) in Life Science",
                "school_name": "school-of-life-science",
                "department": "Life Science",
                "level": "Doctorate",
                "duration": "3 Years",
                "eligibility": "Post Graduation",
                "mode": "Semester",
                "banner_description": "<p>A Doctor of Philosophy (Ph.D.) in life science is an advanced degree program that provides students with the opportunity to conduct original research and contribute to the advancement of knowledge in various fields of life sciences such as biology, biochemistry, genetics, microbiology, neuroscience, and many others.</p>"
            },
            {
                "name": "msc-in-bio-technology",
                "title": "M.Sc. in Bio Technology",
                "school_name": "school-of-life-science",
                "department": "Life Science",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation with Science (with respective subjects)",
                "mode": "Semester",
                "banner_description": "<p>A M.Sc. in Biotechnology is a graduate level degree program that provides advanced training in the field of biotechnology, which involves the use of living organisms or their products to create useful products or processes.</p>"
            },
            {
                "name": "msc-in-microbiology",
                "title": "M.Sc. in Microbiology",
                "school_name": "school-of-life-science",
                "department": "Life Science",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation with Science (with respective subjects)",
                "mode": "Semester",
                "banner_description": "<p>The M.Sc. in Microbiology is a postgraduate course in microbiology. Biochemistry is a discipline in which scientists add chemistry and biology to study relationships with living systems and the environment.</p>"
            },
            {
                "name": "bsc-in-bio-technology",
                "title": "B.Sc. (Hons) in Bio Technology",
                "school_name": "school-of-life-science",
                "department": "Life Science",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent (in science stream)",
                "mode": "Semester",
                "banner_description": "<p>A B.Sc. (Hons) in Bio-Technology is focuses on the study of living organisms and their interactions with the environment, as well as the application of biological principles and techniques to develop new technologies and products.</p>"
            },
            {
                "name": "bsc-in-microbiology",
                "title": "B.Sc. (Hons) in Microbiology",
                "school_name": "school-of-life-science",
                "department": "Life Science",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent (in science stream)",
                "mode": "Semester",
                "banner_description": "<p>A B.Sc. (Hons) in Microbiology is an undergraduate degree program that focuses on the study of microorganisms such as bacteria, viruses, fungi, protozoa, and algae. The program typically combines coursework in biology, chemistry, and related subjects with laboratory work, research, and practical experience.</p>"
            }
        ]
    },
    {
        "title": "School of Yoga and Naturopathy",
        "id": "school-of-yoga-and-naturopathy",
        "banner": "schoolofyoga",
        "icon": "",
        "courses": [
            {
                "name": "doctor-of-philosophy-in-yoga-science-and-naturopathy",
                "title": "Doctor of Philosophy (Ph.D.) in Yoga Science and Naturopathy",
                "school_name": "school-of-yoga-and-naturopathy",
                "department": "Yoga and Naturopathy",
                "level": "Doctorate",
                "duration": "3 Years",
                "eligibility": "Post Graduation",
                "mode": "Semester",
                "banner_description": "<p>A Doctor of Philosophy (Ph.D.) in Yoga Science and Naturopathy would typically involve advanced research and study in the fields of yoga, meditation, and natural healing practices. The program would be designed for individuals who have a strong foundation in these areas and who are interested in conducting original research and contributing to the field's body of knowledge.</p>"
            },
            {
                "name": "msc-in-yoga-science-and-naturopathy",
                "title": "M.Sc. in Yoga Science and Naturopathy",
                "school_name": "school-of-yoga-and-naturopathy",
                "department": "Yoga and Naturopathy",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>A M.Sc. (MSc) in Yoga Science and Naturopathy combines the principles and practices of yoga, natural healing, and alternative medicine. This program typically covers topics such as yoga philosophy, yoga therapy, anatomy and physiology, herbal medicine, nutrition, and lifestyle counseling.</p>"
            },
            {
                "name": "ma-in-yoga",
                "title": "M.A. in Yoga",
                "school_name": "school-of-yoga-and-naturopathy",
                "department": "Yoga and Naturopathy",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>A M.A. in Yoga is a program that focuses on the study of yoga philosophy, theory, and practice. A M.A. in Yoga can prepare graduates for a variety of career paths, including yoga teacher, yoga therapist, researcher, author, or academic. Graduates may also choose to open their own yoga studio or wellness center.</p>"
            },
            {
                "name": "bsc-in-yoga-science-and-naturopathy",
                "title": "B.Sc. (Hons) in Yoga Science and Naturopathy",
                "school_name": "school-of-yoga-and-naturopathy",
                "department": "Yoga and Naturopathy",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent (in Science Stream)",
                "mode": "Semester",
                "banner_description": "<p>A B.Sc. (Hons) in Yoga Science and Naturopathy is an undergraduate degree program that combines the principles of Yoga, Naturopathy, and Ayurveda to promote overall health and well-being. The program typically designed to provide students with a comprehensive understanding of the ancient Indian healing systems.</p>"
            },
            {
                "name": "ba-in-yoga",
                "title": "B.A. (Hons) in Yoga",
                "school_name": "school-of-yoga-and-naturopathy",
                "department": "Yoga and Naturopathy",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>Graduates of a B.A. (Hons) in Yoga program may pursue a variety of career paths, including teaching yoga, working in yoga studios or wellness centers, or pursuing further academic study in the field. They may also choose to integrate their knowledge of yoga with other fields, such as healthcare or education, to develop innovative approaches to wellness and personal development.</p>"
            },
            {
                "name": "post-graduate-diploma-in-yoga-and-naturopathy",
                "title": "Post Graduate Diploma in Yoga and Naturopathy",
                "school_name": "school-of-yoga-and-naturopathy",
                "department": "Yoga and Naturopathy",
                "level": "Post Graduate Diploma",
                "duration": "1 Year",
                "eligibility": "Graduation or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>Post Graduate Diploma in Yoga and Naturopathy is a one-year Post Graduate Diploma program that offers a thorough study of the textual and practical aspects of yoga therapy.</p>"
            },
            {
                "name": "diploma-in-yoga",
                "title": "Diploma in Yoga (DIY)",
                "school_name": "school-of-yoga-and-naturopathy",
                "department": "Yoga and Naturopathy",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>The Diploma in Yoga (DIY) program is designed for individuals who are interested in deepening their understanding and practice of yoga, as well as those who aspire to become yoga instructors or teachers.</p>"
            },
            {
                "name": "diploma-in-naturopathy",
                "title": "Diploma in Naturopathy (DN)",
                "school_name": "school-of-yoga-and-naturopathy",
                "department": "Yoga and Naturopathy",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>As on today, Naturopathy is Recognized and well accepted as an independent System of Medicine. Naturopathic medicine treats the patient from the preventive stage through to serious, chronic and debilitating disease.</p>"
            }
        ]
    },
    {
        "title": "School of Law",
        "id": "school-of-law",
        "banner": "schooloflaw",
        "icon": "",
        "courses": [
            {
                "name": "doctor-of-philosophy-in-law",
                "title": "Doctor Of Philosophy (Ph.d.) In Law",
                "school_name": "school-of-law",
                "department": "Law",
                "level": "Doctorate",
                "duration": "3 Year",
                "eligibility": "Post Graduation",
                "mode": "Semester",
                "banner_description": "<p>PhD Law Degree is a three years full-time doctorate program within the field of Law. PhD in Law Studies involves in-depth research and a blended learning approach to turn lawyers into legal masterminds.</p>"
            },
            {
                "name": "master-of-law",
                "title": "Master of Law (LLM)",
                "school_name": "school-of-law",
                "department": "Law",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "LLB",
                "mode": "Semester",
                "banner_description": "<p>The School of Law offers Master's degrees in Law. Students will be able to continue their basic general education and choose, according to their interests and professional projects, more specific orientations.</p>"
            },
            {
                "name": "bachelor-of-law",
                "title": "Bachelor Of Law (Llb)",
                "school_name": "school-of-law",
                "department": "Law",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The LLB degree course also known as Bachelor of Legislative Law, gives students a systemic understanding of law, along with analytical and strategic thinking skills necessary for navigating the field of legalities. LLB course is designed for students who aspire to be a corporate, civil or a criminal lawyer.</p>"
            },
            {
                "name": "bachelor-of-business-administration-and-bachelor-of-law",
                "title": "Bachelor of Business Administration and Bachelor of Law (BBA LLB)",
                "school_name": "school-of-law",
                "department": "Law",
                "level": "Undergraduate",
                "duration": "5 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>A Bachelor of Business Administration and Bachelor of Law (BBA-LLB) is a dual-degree program that combines the study of business administration with the study of law. The BBA component of the program includes courses in accounting, finance, marketing, management, and economics. The LLB component of the program covers subjects such as contracts, torts, property law, criminal law, constitutional law, administrative law, and civil procedure.</p>"
            },
            {
                "name": "bachelor-of-arts-and-bachelor-of-law",
                "title": "Bachelor of Arts and Bachelor of Law (BA LLB)",
                "school_name": "school-of-law",
                "department": "Law",
                "level": "Undergraduate",
                "duration": "5 Years",
                "eligibility": "10+2 or Equivalent (Proposed)",
                "mode": "Semester",
                "banner_description": "<p>\n  The <strong>Bachelor of Arts and Bachelor of Laws (BA LLB Degree)</strong> is an integrated undergraduate degree program that combines the study of law with humanities and social sciences. It provides students with a comprehensive understanding of law and legal principles, along with a broader perspective on society, politics, governance, and culture, preparing them for successful careers in the legal profession and related fields.\n</p>"
            },
            {
                "name": "post-graduate-diploma-in-law",
                "title": "Post Graduate Diploma in Law",
                "school_name": "school-of-law",
                "department": "Law",
                "level": "Post Graduate Diploma",
                "duration": "1 Year",
                "eligibility": "Graduation or Equivalent",
                "mode": "Annual",
                "banner_description": "<div>The PGDL program covers topics such as legal systems and processes, contract law, criminal law, property law, and tort law. The course also includes training in legal research, analysis, and writing, as well as advocacy and negotiation skills.</div>"
            },
            {
                "name": "diploma-in-law",
                "title": "Diploma in Law",
                "school_name": "school-of-law",
                "department": "Law",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>A Diploma in Law is a qualification that provides an understanding of the fundamental principles of law. It is typically a one-year course of study that is designed for individuals who wish to gain a basic knowledge of law without committing to a full undergraduate or graduate law degree.</p>"
            }
        ]
    },
    {
        "title": "School of Library and Information Science",
        "id": "school-of-library-and-information-science",
        "banner": "schooloflibrary",
        "icon": "",
        "courses": [
            {
                "name": "doctor-of-philosophy-in-library-and-information-science",
                "title": "Doctor of Philosophy (Ph.D.) in Library and Information Science",
                "school_name": "school-of-library-and-information-science",
                "department": "Library and Information Science",
                "level": "Doctorate",
                "duration": "3 Years",
                "eligibility": "Post Graduation",
                "mode": "Semester",
                "banner_description": "<p>A Doctor of Philosophy (Ph.D.) in Library and Information Science (LIS) is a research-intensive program that focuses on the theory and practice of information organization, management, retrieval, and dissemination. This program is designed for individuals who aspire to become researchers, scholars, educators, and leaders in the LIS field.</p>"
            },
            {
                "name": "master-of-library-and-information-science",
                "title": "Master of Library and Information Science (M.Lib. & I.Sc.)",
                "school_name": "school-of-library-and-information-science",
                "department": "Library and Information Science",
                "level": "Postgraduate",
                "duration": "1 Year",
                "eligibility": "B.Lib",
                "mode": "Semester",
                "banner_description": "<p>Master of Library and Information Science is a post graduate program structured to make students understand the significance of preserved records and data and how they are beneficial for various purposes.</p>"
            },
            {
                "name": "bachelor-of-library-and-information-science",
                "title": "Bachelor of Library and Information Science (B.Lib. & I.Sc.)",
                "school_name": "school-of-library-and-information-science",
                "department": "Library and Information Science",
                "level": "Undergraduate",
                "duration": "1 Year",
                "eligibility": "Graduation or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>B.Lib. &amp; I.Sc. program trains students in modern library administration, along-with leading a career to other jobs in the field, including work in public, school, corporate, military, museum or special research library.</p>"
            }
        ]
    },
    {
        "title": "School of Journalism and Mass Communication",
        "id": "school-of-journalism-and-mass-communication",
        "banner": "schoolofjournalism",
        "icon": "",
        "courses": [
            {
                "name": "doctor-of-philosophy-in-journalism-and-mass-communication",
                "title": "Doctor of Philosophy (Ph.D.) in Journalism and Mass Communication",
                "school_name": "school-of-journalism-and-mass-communication",
                "department": "Journalism",
                "level": "Doctorate",
                "duration": "3 Years",
                "eligibility": "Post Graduation",
                "mode": "Semester",
                "banner_description": "<p>A Doctor of Philosophy (Ph.D.) in Journalism and Mass Communication is a rigorous academic program that focuses on advanced research and critical analysis of media and communication theories, practices, and industries. The program aims to produce scholars who can contribute to the development and advancement of knowledge in the field of journalism and mass communication.</p>"
            },
            {
                "name": "master-of-arts-in-journalism-and-mass-communication",
                "title": "Master of Arts in Journalism and Mass Communication (MA JMC)",
                "school_name": "school-of-journalism-and-mass-communication",
                "department": "Journalism",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>Master of Journalism &amp; Mass Communication is a postgraduate mass communication course of two years duration. The course involves the study of different forms of mass media including newspapers, radio, television, films, etc. to convey information to a large audience.</p>"
            },
            {
                "name": "bachelor-of-arts-in-journalism-and-mass-communication",
                "title": "Bachelor of Arts (Hons) in Journalism and Mass Communication (BA JMC)",
                "school_name": "school-of-journalism-and-mass-communication",
                "department": "Journalism",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p><span style=\"font-family: Oswald, sans-serif;\">Bachelor of Arts (Hons) in Journalism and Mass Communication (BA-JMC) is an undergraduate program that provides aspirants with knowledge about various journalistic skills in mass media such as newspapers, television, radio, internet etc.</span><br></p>"
            },
            {
                "name": "diploma-in-journalism-and-mass-communication",
                "title": "Diploma in Journalism and Mass Communication (D JMC)",
                "school_name": "school-of-journalism-and-mass-communication",
                "department": "Journalism",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>The curriculum is evenly balanced for imparting technical skills and theoretical knowledge in various domains of Mass Communication and Mass Media,which determine the nature use, historical and social understanding of the social dynamics.</p>"
            }
        ]
    },
    {
        "title": "School of Education",
        "id": "school-of-education",
        "banner": "schoolofeducation",
        "icon": "",
        "courses": [
            {
                "name": "doctor-of-philosophy-in-education",
                "title": "Doctor of Philosophy (Ph.D.) in Education",
                "school_name": "school-of-education",
                "department": "Education",
                "level": "Doctorate",
                "duration": "3 Years",
                "eligibility": "Post Graduation",
                "mode": "Semester",
                "banner_description": "<p>A Doctor of Philosophy (Ph.D.) in Education is a doctoral-level degree program that focuses on the study of educational theory, research, and practice. The program is designed to prepare graduates to become scholars, researchers, and practitioners in the field of education.</p>"
            },
            {
                "name": "master-of-arts-in-education",
                "title": "Master of Arts in Education",
                "school_name": "school-of-education",
                "department": "Education",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation",
                "mode": "Semester",
                "banner_description": "<p>Master of Arts in Education program typically focuses on developing the skills and knowledge necessary to become an effective educator or educational leader, with coursework covering topics such as curriculum design, instructional methods, assessment, and educational research.</p>"
            },
            {
                "name": "bachelor-of-arts-in-education",
                "title": "Bachelor of Arts (Hons) in Education",
                "school_name": "school-of-education",
                "department": "Education",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or equivalent (Any Stream)",
                "mode": "Semester",
                "banner_description": "<p>Teaching has always been one of the most popular career choices among students. However, to become a teacher at pre-nursery to senior secondary levels in schools or to become a professor at the college/university level, aspirants need to possess the right qualifications.</p>"
            }
        ]
    },
    {
        "title": "School of Hotel Management",
        "id": "school-of-hotel-management",
        "banner": "schoolofhm",
        "icon": "",
        "courses": [
            {
                "name": "doctor-of-philosophy-in-hotel-management-and-catering-technology",
                "title": "Doctor of Philosophy (Ph.D.) in Hotel Management and Catering Technology",
                "school_name": "school-of-hotel-management",
                "department": "Hotel Management",
                "level": "Doctorate",
                "duration": "3 Years",
                "eligibility": "Post Graduation",
                "mode": "Semester",
                "banner_description": "<p>A Doctor of Philosophy (Ph.D.) in Hotel Management and Catering Technology is a research-oriented program designed to provide advanced knowledge and expertise in the field of hospitality management.</p>"
            },
            {
                "name": "master-of-hotel-management-and-catering-technology",
                "title": "Master of Hotel Management and Catering Technology (Proposed)",
                "school_name": "school-of-hotel-management",
                "department": "Hotel Management",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation or Equivalent (with respective subjects)",
                "mode": "Semester",
                "banner_description": "<p>A Master of Hotel Management and Catering Technology is a postgraduate program that focuses on developing the skills and knowledge required to manage and operate hotels, resorts, and other hospitality businesses.</p>"
            },
            {
                "name": "bachelor-of-hotel-management-and-catering-technology",
                "title": "Bachelor of Hotel Management and Catering Technology (BHMCT)",
                "school_name": "school-of-hotel-management",
                "department": "Hotel Management",
                "level": "Undergraduate",
                "duration": "4 Years",
                "eligibility": "10+2 or equivalent (Any Stream)",
                "mode": "Semester",
                "banner_description": "<p>Starting with the basics of hotel management, the course sails into more detailed and professional aspects of catering and hospitality.</p>"
            },
            {
                "name": "diploma-in-hotel-management-and-catering-technology",
                "title": "Diploma in Hotel Management and Catering Technology (DHMCT)",
                "school_name": "school-of-hotel-management",
                "department": "Hotel Management",
                "level": "Diploma",
                "duration": "3 Years",
                "eligibility": "10+2 or equivalent (Any Stream)",
                "mode": "Semester",
                "banner_description": "<p>The objective of Diploma in Hotel Management program is to provide eligible candidates with the necessary skills, knowledge, values, and attitudes to occupy key operational positions in the hotel industry.</p>"
            },
            {
                "name": "diploma-in-culinary-arts",
                "title": "Diploma in Culinary Arts",
                "school_name": "school-of-hotel-management",
                "department": "Hotel Management",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or equivalent (Any Stream)",
                "mode": "Annual",
                "banner_description": "<p>A Diploma in Culinary Arts is a program designed to provide students with a solid foundation in the culinary arts, including cooking techniques, food preparation, nutrition, kitchen management, and other related subjects.</p>"
            },
            {
                "name": "diploma-in-travel-and-tourism",
                "title": "Diploma in Travel & Tourism",
                "school_name": "school-of-hotel-management",
                "department": "Hotel Management",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or equivalent (Any Stream)",
                "mode": "Annual",
                "banner_description": "A Diploma in Travel and Tourism is a qualification that provides students with a comprehensive understanding of the travel and tourism industry"
            },
            {
                "name": "bsc-hotel-management",
                "title": "Bsc (Hotel Management)",
                "school_name": "school-of-hotel-management",
                "department": "Hotel Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>A B.Sc. in Hotel Management by ISBM University is a 3-year undergraduate degree. It prepares students for supervisory and managerial careers in the hospitality, travel, and tourism sectors through a mix of hands-on laboratory training and business management coursework.</p>"
            },
            {
                "name": "msc-hotel-management",
                "title": "Msc (Hotel Management)",
                "school_name": "school-of-hotel-management",
                "department": "Hotel Management",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation in BSc Hotel Management or Hospitality Studies",
                "mode": "Semester",
                "banner_description": "<p>The MSc in Hotel Management by ISBM University is a postgraduate programme designed to develop advanced expertise in hospitality operations, strategic management, guest experience, and service innovation.</p>"
            }
        ]
    },
    {
        "title": "School of Health and Allied Science",
        "id": "school-of-health-and-allied-science",
        "banner": "schoolofhealth",
        "icon": "",
        "courses": [
            {
                "name": "msc-in-medical-biotechnology",
                "title": "M.Sc. in Medical Biotechnology (M.Sc. MBT)",
                "school_name": "school-of-health-and-allied-science",
                "department": "Health and Allied Science",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation with Science (In related field of specialization)",
                "mode": "Semester",
                "banner_description": "<p>Your undergraduate degree will demonstrate your proficiency in one area, while a Master of Science (MSc) degree will demonstrate to employers your level of expertise in a specific area of study.</p>"
            },
            {
                "name": "bachelor-of-physiotherapy",
                "title": "Bachelor of Physiotherapy",
                "school_name": "school-of-health-and-allied-science",
                "department": "Health and Allied Science",
                "level": "Undergraduate",
                "duration": "4.5 Years",
                "eligibility": "10+2 or Equivalent (in Science Stream, Biology as Core Subject)",
                "mode": "Semester",
                "banner_description": "<p>Bachelor of Physiotherapy is an undergraduate program in the field of healthcare and medicine. The program is designed to provide students with the knowledge and skills necessary to become a physiotherapist. Physiotherapy is a branch of healthcare that focuses on the prevention, treatment, and management of physical impairments, disabilities, and pain.</p>"
            },
            {
                "name": "bsc-in-forensic-science",
                "title": "B.Sc. (Hons) in Forensic Science",
                "school_name": "school-of-health-and-allied-science",
                "department": "Health and Allied Science",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent (in Science Stream)",
                "mode": "Semester",
                "banner_description": "<p>The curriculum of the program covers a range of subjects such as chemistry, biology, physics, mathematics, forensic toxicology, forensic pathology, forensic anthropology, and forensic psychology. Students also learn about crime scene investigation, evidence collection and analysis, forensic techniques and technologies, and legal aspects of forensic science.</p>"
            },
            {
                "name": "bsc-in-nutrition-and-dietetics",
                "title": "B.Sc. (Hons) in Nutrition & Dietetics",
                "school_name": "school-of-health-and-allied-science",
                "department": "Health and Allied Science",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent (in Science Stream)",
                "mode": "Semester",
                "banner_description": "<p>A B.Sc. (Hons) in Nutrition and Dietetics is an undergraduate degree program that prepares students for a career in the field of nutrition and dietetics. The program typically takes four years to complete and focuses on the scientific study of food, nutrition, and diet.</p>"
            },
            {
                "name": "ba-in-public-health",
                "title": "B.A. (Hons) in Public Health",
                "school_name": "school-of-health-and-allied-science",
                "department": "Health and Allied Science",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>A B.A. (Hons) in Public Health is an undergraduate degree program that focuses on the study of public health and its role in improving the health and well-being of communities. This program typically combines coursework in the social sciences, humanities, and natural sciences to provide students with a comprehensive understanding of public health issues.</p>"
            },
            {
                "name": "post-graduate-diploma-in-nutrition-and-dietetics",
                "title": "Post Graduate Diploma in Nutrition and Dietetics",
                "school_name": "school-of-health-and-allied-science",
                "department": "Health and Allied Science",
                "level": "Post Graduate Diploma",
                "duration": "1 Year",
                "eligibility": "Graduation in Any Stream",
                "mode": "Annual",
                "banner_description": "<p>A Post Graduate Diploma in Nutrition and Dietetics is a program that provides advanced training in the field of nutrition and dietetics. This diploma is designed for individuals who have completed a Undergraduate (UG) in nutrition, food science, or a related field and wish to pursue a career in the field of nutrition.</p>"
            },
            {
                "name": "diploma-in-dietetics",
                "title": "Diploma in Dietetics",
                "school_name": "school-of-health-and-allied-science",
                "department": "Health and Allied Science",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>A Diploma in Dietetics is an educational program that provides students with the knowledge and skills necessary to become a dietitian or nutritionist. It covers topics such as nutrition science, food science, medical nutrition therapy, community nutrition, and foodservice management.</p>"
            },
            {
                "name": "diploma-in-nutrition",
                "title": "Diploma in Nutrition",
                "school_name": "school-of-health-and-allied-science",
                "department": "Health and Allied Science",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>ISBM University is committed to building a strong and sustainable Indian health and sport industry workforce. Successful graduates from this diploma program are well-placed to progress to become qualified as a dietitian.</p>"
            }
        ]
    },
    {
        "title": "School Of Vocational Management",
        "id": "school-of-vocational-management",
        "banner": "schoolofvocational",
        "icon": "",
        "courses": [
            {
                "name": "bachelor-of-vocational-management",
                "title": "Bachelor of Vocational Management",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>Bachelor of Vocational Management(B.Voc.) is an undergraduate degree program that focuses on imparting practical and vocational skills to students in various fields. The program aims to prepare students for specific careers and industries by providing them with hands-on training and industry-oriented curriculum.</p>"
            },
            {
                "name": "diploma-in-vocational-management",
                "title": "Diploma in Vocational Management",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Diploma",
                "duration": "2 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>The curriculum of a Diploma in Vocational Management program is focused on the practical application of knowledge and skills. Students may learn a range of topics, depending on the program they choose, such as welding, automotive repair, graphic design, culinary arts, nursing, or cosmetology.</p>"
            },
            {
                "name": "certificate-in-vocational-management",
                "title": "Certificate in Vocational Management",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Certificate",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>A Certificate in Vocational Management is a type of certificate program that provides individuals with practical skills and knowledge in a specific vocational field. These programs are often designed to prepare individuals for entry-level jobs in a particular industry, such as healthcare, information technology, or construction.</p>"
            },
            {
                "name": "bvoc-in-software-web-development",
                "title": "B.voc In Software & Web Development",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>A B.Voc in Software &amp; Web Development is a 3-year degree programme focused on practical, industry-aligned IT skills. It typically dedicates 60% of the curriculum to hands-on training and internships, preparing you for immediate employment in the tech industry.</p>"
            },
            {
                "name": "bvoc-in-networking-system-maintenance",
                "title": "B.voc In Networking & System Maintenance",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>B.Voc in Networking &amp; System Maintenance is a 3-year skill-oriented graduation programme designed to develop expertise in computer networks, system administration, IT infrastructure, and technical support. It dedicates 60% of the curriculum to hands-on training and internships, preparing you for immediate employment in the IT industry.</p>"
            },
            {
                "name": "bvoc-in-cloud-computing",
                "title": "B.voc In Cloud Computing",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The B.Voc in Cloud Computing by ISBM University is a degree programme that prepares students for careers in cloud technologies, IT infrastructure, virtualization, and digital transformation. This vocational programme emphasizes practical learning, industry-focused training, and hands-on experience to meet the growing demand for cloud computing professionals.</p>"
            },
            {
                "name": "bvoc-in-programming-with-python",
                "title": "B.voc In Programming With Python",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The B.Voc in Programming with Python by ISBM University is a 3-year skill-oriented undergraduate programme designed to equip students with industry-relevant programming, software development, and problem-solving skills. The programme emphasizes practical learning, hands-on projects, and real-world application development to prepare students for careers in the technology sector.</p>"
            },
            {
                "name": "bvoc-in-graphic-multimedia",
                "title": "B.voc In Graphic & Multimedia",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The B.Voc in Graphic &amp; Multimedia is a 3-year undergraduate programme that combines creativity with technology to prepare students for careers in design, digital media, branding, and multimedia production. Through hands-on learning and industry-focused training, students develop the skills needed to create engaging visual content across print, digital, and interactive platforms.</p>"
            },
            {
                "name": "bvoc-in-digital-marketing",
                "title": "B.voc In Digital Marketing",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The B.Voc in Digital Marketing is a 3-year skill-based undergraduate programme designed to prepare students for careers in online marketing, content creation, social media, advertising, and digital business growth. Through practical training and industry-focused learning, students develop expertise in SEO, social media marketing, content strategy, performance marketing, web analytics, and digital branding, equipping them with the skills required to succeed in today's digital-first economy.</p>"
            },
            {
                "name": "bvoc-in-fashion-designing",
                "title": "B.voc In Fashion Designing",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The B.Voc in Fashion Designing is a 3-year skill-development undergraduate programme by ISBM University, designed for students who aspire to build careers in fashion, apparel, styling, and creative design. Combining artistic creativity with industry-focused training, the programme helps students transform design concepts into market-ready fashion products</p>"
            },
            {
                "name": "bvoc-in-interior-designing",
                "title": "B.voc In Interior Designing",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The B.Voc in Interior Designing is a 3-year skill-focused undergraduate programme designed for students who aspire to create functional, aesthetically appealing, and user-centric interior spaces. The programme combines creativity, design thinking, and technical expertise to prepare learners for careers in residential, commercial, retail, hospitality, and institutional interior design.</p>"
            },
            {
                "name": "bvoc-in-jewellery-designing",
                "title": "B.voc In Jewellery Designing",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The B.Voc in Jewellery Designing by ISBM University is a 3-year skill-based undergraduate programme that blends creativity, craftsmanship, and technology to prepare students for careers in the jewellery and luxury goods industry. Through hands-on training in jewellery design, gemology, CAD, and product development, students learn to create innovative designs that meet evolving market trends and consumer preferences.</p>"
            },
            {
                "name": "bvoc-in-music",
                "title": "B.voc In Music",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The B.Voc in Music is a 3-year undergraduate programme designed for aspiring performers, composers, music producers, and creative professionals. Combining artistic expression with practical training, the programme helps students develop technical proficiency, musical creativity, and performance skills across diverse musical traditions and contemporary formats.</p>"
            },
            {
                "name": "bvoc-in-sports-management",
                "title": "B.voc In Sports Management",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The B.Voc in Sports Management is a 3-year skill-intensive degree programme that combines sports, business, and management to prepare students for careers in the rapidly growing sports industry. Through practical training and industry exposure, students develop expertise in sports marketing, event management, athlete management, sports administration, and sports business operations.</p>"
            },
            {
                "name": "bvoc-in-event-management",
                "title": "B.voc In Event Management",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The B.Voc in Event Management is a 3-year undergraduate programme that prepares students to plan, manage, and execute memorable events and brand experiences. Combining creativity with business and organizational skills, the programme equips learners for careers across corporate events, entertainment, weddings, exhibitions, hospitality, and experiential marketing industries.</p>"
            },
            {
                "name": "bvoc-in-food-processing-engineering",
                "title": "B.voc In Food Processing Engineering",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The B.Voc in Food Processing Engineering by ISBM University is a 3-year skill-based undergraduate programme designed to prepare students for careers in food manufacturing, processing, quality assurance, and food technology. Combining scientific knowledge with industry-focused training, the programme equips learners with the skills required to transform raw agricultural products into safe, nutritious, and value-added food products while meeting modern industry standards.</p>"
            },
            {
                "name": "bvoc-in-pharmaceutical-manufacturing",
                "title": "B.voc In Pharmaceutical Manufacturing",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The B.Voc in Pharmaceutical Manufacturing is a 3-year skill-oriented undergraduate programme designed to prepare students for careers in pharmaceutical production, quality assurance, drug manufacturing, and healthcare-related industries.</p>"
            },
            {
                "name": "bvoc-in-electronic-manufacturing",
                "title": "B.voc In Electronic Manufacturing",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The B.Voc in Electronic Manufacturing is a 3-year skill-oriented graduation programme designed to prepare students for careers in electronics production, assembly, testing, quality assurance, and manufacturing operations. As industries increasingly rely on advanced electronic systems and smart technologies, the demand for skilled professionals in electronics manufacturing continues to grow.</p>"
            },
            {
                "name": "bvoc-in-cyber-law",
                "title": "B.voc In Cyber Law",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The B.Voc in Cyber Law by ISBM University is a 3-year skill-based degree programme that equips students with expertise in digital laws, cybercrime, data privacy, cybersecurity regulations, and technology governance. Designed for the digital age, the programme prepares learners to address legal, ethical, and compliance challenges arising from the growing use of technology and online platforms.</p>"
            },
            {
                "name": "bvoc-in-tally-gst",
                "title": "B.voc In Tally & Gst",
                "school_name": "school-of-vocational-management",
                "department": "Vocational Management",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>The B.Voc in Tally &amp; GST by ISBM University, is a 3-year skill-based undergraduate programme that equips students with practical expertise in accounting, taxation, financial reporting, and business compliance. Through hands-on training in Tally, GST, bookkeeping, and payroll management, the programme prepares learners for careers in accounting, finance, and taxation across industries.</p>"
            }
        ]
    },
    {
        "title": "School of Media and Entertainment",
        "id": "school-of-media-and-entertainment",
        "banner": "schoolofmedia",
        "icon": "",
        "courses": [
            {
                "name": "doctor-of-philosophy-in-media-and-entertainment",
                "title": "Doctor of Philosophy (Ph.D.) in Media and Entertainment",
                "school_name": "school-of-media-and-entertainment",
                "department": "Media and Entertainment",
                "level": "Doctorate",
                "duration": "3 Years",
                "eligibility": "Post Graduation",
                "mode": "Semester",
                "banner_description": "<p>A Doctor of Philosophy (Ph.D.) in Media and Entertainment would typically focus on the theoretical and practical aspects of the media and entertainment industry. Students in this program may study topics such as media ethics, media law, media policy, media management, media production, and media history.</p>"
            },
            {
                "name": "ma-in-film-making-and-advertising",
                "title": "M.A. in Film Making and Advertising",
                "school_name": "school-of-media-and-entertainment",
                "department": "Media and Entertainment",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation in any Stream",
                "mode": "Semester",
                "banner_description": "<p>Graduates of this program may pursue careers as filmmakers, advertising executives, producers, directors, cinematographers, editors, or sound designers, among other roles in the film and advertising industries.</p>"
            },
            {
                "name": "ma-in-public-relation-and-event-management",
                "title": "M.A. in Public Relation and Event Management",
                "school_name": "school-of-media-and-entertainment",
                "department": "Media and Entertainment",
                "level": "Postgraduate",
                "duration": "2 Years",
                "eligibility": "Graduation in any Stream",
                "mode": "Semester",
                "banner_description": "<p>A M.A. in Public Relations and Event Management is a graduate-level degree program that focuses on the strategic management and execution of public relations campaigns and events.</p>"
            },
            {
                "name": "ba-in-film-making-and-advertising",
                "title": "B.A. (Hons) in Film Making and Advertising",
                "school_name": "school-of-media-and-entertainment",
                "department": "Media and Entertainment",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>Graduates of a B.A. (Hons) in Film Making and Advertising degree program may pursue a variety of careers in the film and advertising industries, including film director, producer, screenwriter, cinematographer, editor, advertising creative director, brand manager, media planner, and account executive.</p>"
            },
            {
                "name": "ba-in-public-relation-and-event-management",
                "title": "B.A. (Hons) in Public Relation and Event Management",
                "school_name": "school-of-media-and-entertainment",
                "department": "Media and Entertainment",
                "level": "Undergraduate",
                "duration": "3 Years",
                "eligibility": "10+2 or Equivalent",
                "mode": "Semester",
                "banner_description": "<p>A B.A. (Hons) in Public Relations and Event Management is an undergraduate degree program that focuses on the principles, practices, and skills needed to plan, execute, and evaluate public relations and event management campaigns.</p>"
            },
            {
                "name": "diploma-in-photography",
                "title": "Diploma in Photography",
                "school_name": "school-of-media-and-entertainment",
                "department": "Media and Entertainment",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>Graduates of a diploma in photography program can work as professional photographers or pursue careers in related fields such as photojournalism, advertising, and graphic design. They can also start their own photography businesses or work as freelance photographers.</p>"
            },
            {
                "name": "diploma-in-script-writing",
                "title": "Diploma in Script Writing",
                "school_name": "school-of-media-and-entertainment",
                "department": "Media and Entertainment",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>Students will learn how to research and develop ideas, write treatments, and create compelling scripts that engage audiences. They may also explore different genres and styles, such as comedy, drama, and action, and learn how to adapt existing material for the screen.</p>"
            },
            {
                "name": "diploma-in-advertising",
                "title": "Diploma in Advertising",
                "school_name": "school-of-media-and-entertainment",
                "department": "Media and Entertainment",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>The curriculum of a Diploma in Advertising typically includes courses in advertising strategy, consumer behavior, media planning, copywriting, creative design, and digital marketing. The program may also include courses in marketing research, branding, and public relations.</p>"
            },
            {
                "name": "diploma-in-branding",
                "title": "Diploma in Branding",
                "school_name": "school-of-media-and-entertainment",
                "department": "Media and Entertainment",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>A Diploma in Branding is a specialized program that provides students with a comprehensive understanding of branding, marketing, and advertising. This program covers various aspects of branding such as brand strategy, brand management, brand identity, brand positioning, and brand communication.</p>"
            },
            {
                "name": "diploma-in-vfx-and-animation",
                "title": "Diploma in VFX and Animation",
                "school_name": "school-of-media-and-entertainment",
                "department": "Media and Entertainment",
                "level": "Diploma",
                "duration": "1 Year",
                "eligibility": "10+2 or Equivalent",
                "mode": "Annual",
                "banner_description": "<p>A Diploma in VFX (Visual Effects) and Animation is a program that provides students with practical training and theoretical knowledge in the fields of 2D and 3D animation, special effects, motion graphics, and compositing.</p>"
            }
        ]
    }
];

export default schools;
